export const pickLatestItem = <T>(items: T[] | undefined, getDate: (item: T) => Date | string): T | undefined =>
  items?.reduce<T | undefined>(
    (latest, item) =>
      !latest || new Date(getDate(item)).getTime() > new Date(getDate(latest)).getTime() ? item : latest,
    undefined,
  );
